'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoneyValue = undefined;

var _MoneyValue2 = require('./MoneyValue');

var _MoneyValue3 = _interopRequireDefault(_MoneyValue2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MoneyValue = _MoneyValue3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/MoneyValue/index.js
// module id = 1694
// module chunks = 0